import { type Currency } from '../domain/Currency'
import { type Mode } from '../domain/Mode'
import { isDrayageMode } from '../domain/RequestForProposal'

export function getCurrencyPrefix(currency: Currency): string {
  switch (currency) {
    case 'CAD':
      return 'C$'
    case 'MXN':
      return 'MX$'
    default:
      return '$'
  }
}

export function getFormattedCurrency(currency: Currency) {
  switch (currency) {
    case 'CAD':
      return 'C$'
    case 'MXN':
      return 'MX$'
    default:
      return 'US$'
  }
}

export function getInputStatus(hasError: boolean) {
  return hasError ? 'danger' : 'neutral'
}

export function formatLaneResults(variance: string) {
  return variance.replace(/(^-|\s\+$)/, '')
}

export function getEquipmentColumnName(rfpMode: Mode) {
  const hideEquipmentType = isDrayageMode(rfpMode)

  return `Equipment${hideEquipmentType ? '' : ' Type'}`
}

export function formatDistanceColumnName(distanceUnit: string) {
  return distanceUnit === 'miles' ? 'miles' : 'kilometers'
}

export function formatRatePerDistanceColumnName(distanceUnit: string, formattedCurrency: string) {
  return `Rate/${distanceUnit === 'miles' ? 'Mile' : 'KM'} (${formattedCurrency})`
}
